import React from 'react';
import KickImage from 'Reuseables/KickImage';

const NotesSelling = props => {
  return(
    <div>
      <p style={{textAlign: 'right', color: '#4a4a4a', fontStyle: 'italic', fontSize: '0.5625rem'}}>By clicking SELL NOW, you have agreed to the HIGHEST OFFER price. The order will be placed and a notification will be sent to the potential buyer to complete the payment. Should the payment process fail, your listing will be automatically adjusted that amount.</p>
    </div>
  )
}

export default NotesSelling;